export default __webpack_public_path__ + "img/0240da7bebdbea3851a7399fd201f277.jpg";